import React, { useState, useCallback } from 'react'
import PopoverConfirm from '@/components/popover-confirm/popover-confirm'
import { getBEMCls } from '@/utils/classname'
import { Row } from '@/components/layout/layout'

import './remark-popover.scss'
import { useUpdateEffect } from 'ahooks'

interface RemarkPopoverProps {
    maxLen?: number
    placeholder?: string
    onConfirm: (e: string) => void
    value?: string
}

const RemarkPopover: React.FC<RemarkPopoverProps> = props => {
    const [remark, setRemark] = useState<string>(() => props.value || '')
    const cls = (...arg: string[]) => getBEMCls('remark-popover', ...arg)
    const [visable, setVisable] = useState<boolean>(false)

    useUpdateEffect(() => {
        setRemark(props.value || '')
    }, [props.value])

    const hidden = useCallback(() => {
        setVisable(false)
    }, [])

    return (
        <PopoverConfirm
            placement="topRight"
            trigger="click"
            visible={visable}
            onVisibleChange={visible => {
                setVisable(visible)
            }}
            onCancel={hidden}
            content={
                <Row className={cls()}>
                    <textarea
                        maxLength={props.maxLen}
                        className={cls('text')}
                        placeholder={props.placeholder}
                        onChange={e => {
                            setRemark(e.target.value)
                        }}
                        value={remark}
                    ></textarea>
                    <div className={cls('len')}>
                        {remark.length}/{props.maxLen}
                    </div>
                </Row>
            }
            onConfirm={() => {
                hidden()
                props.onConfirm(remark)
            }}
        >
            {props.children}
        </PopoverConfirm>
    )
}

RemarkPopover.defaultProps = {
    maxLen: 30,
    placeholder: '请输入备注',
}

export default RemarkPopover
